var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "252 168 522 503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,271)",
    d: "m0 0h28l2 2 1 21 6 46 1 12v33l-3 29-6 27-8 26-13 30-8 20-5 11-11 26-10 24-9 22-5 12-9 24-10 30-5 3h-16l-9-2-3-8-6-19-11-52-8-36-2-7-7 47-3 15-4 24-5 19-4 15-6 4-6 1-29 1-22-1-10-2-3-3-10-24-7-15-15-31-9-20-7-16-7-15-28-63-8-19-5-16-4-17-3-18-2-24v-39l3-29 7-40 3-6 2-1h12l10 2 3 6 5 25 5 41 1 13 5 2 13 8 27 14 25 12 21 11 14 8 4 4-3 16-5 18-6 11-6-1-13-5-13-6-14-4-8-1-2 9v15l4 15 9 5 28 12 8 5 3 7 3 24 1 13v10l-1 2-9-1-21-6-2-1 2 12 8 24 8 16 6 10 4 10 2 1 1-5 5-11 6-19 6-24 8-49 6-21 10-22 12-22 6-9 9-10 9-9h3l11 32 16 43 7 18v2l4-4 4-13 3-24 1-13 1-75 3-8 6-7 14-10 11-9h2l1-14 3-25 10-48z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(707,168)",
    d: "m0 0h60l5 2 2 4v143l-3 5-11 2h-55l-2-4-1-34v-47l1-67z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(258,168)",
    d: "m0 0h60l4 4 1 2v143l-3 5-1 1-59 1-6-3-2-4v-143l4-5z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(401,226)",
    d: "m0 0h232l35 1 20 1 1 1v28l-3 1-41-1h-306v-29z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,289)",
    d: "m0 0h10l11 3 10 5 8 7 7 10 4 11 1 5v13l-3 10-6 11-7 8-13 8-5 2-6 1h-14l-9-2-11-6-11-11-6-12-2-8v-15l4-13 9-13h2l1-3 11-7 8-3z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.42066ae7262e96f20c4e842189aacdb1.svg";
export { ForwardRef as ReactComponent };